var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 32,
    viewBox: "0 0 60 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38462 0H0L9.23077 16L0 32H7.38462L16.6154 16L7.38462 0Z",
    fill: "#1C68F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2308 0H31.3846V32H25.2308V0Z",
    fill: "#121212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4615 0V32H43.0769C51.9135 32 59.0769 24.8366 59.0769 16C59.0769 7.16344 51.9135 0 43.0769 0H34.4615ZM40.6154 25.8462H43.0769C48.5148 25.8462 52.9231 21.4379 52.9231 16C52.9231 10.5621 48.5148 6.15385 43.0769 6.15385H40.6154V25.8462Z",
    fill: "#121212"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25.8462,
    width: 6.15385,
    height: 6.15385,
    fill: "#1C68F3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextid);
export default __webpack_public_path__ + "static/media/nextid.dc5e9bf0ae1bf8734eac6d8f94207c81.svg";
export { ForwardRef as ReactComponent };